export const SELECT_DOKUMEN_KERJASAMA = "@dokumenKerjasama/SELECT_USER";

export const INITIALIZE_CREATE_DOKUMEN_KERJASAMA = "@dokumenKerjasama/INITIALIZE_CREATE_DOKUMEN_KERJASAMA";

export const UPDATE_NAME = "@dokumenKerjasama/UPDATE_NAME";

export const UPDATE_JUDUL_DOKUMEN = "@dokumenKerjasama/UPDATE_JUDUL_DOKUMEN";
export const UPDATE_NOMOR_DOKUMEN_INDUK = "@dokumenKerjasama/UPDATE_NOMOR_DOKUMEN_INDUK";
export const UPDATE_NOMOR_DOKUMEN_PT = "@dokumenKerjasama/UPDATE_NOMOR_DOKUMEN_PT";
export const UPDATE_JENIS_DOKUMEN = "@dokumenKerjasama/UPDATE_JENIS_DOKUMEN";
export const UPDATE_NOMOR_DOKUMEN = "@dokumenKerjasama/UPDATE_NOMOR_DOKUMEN";
export const UPDATE_DESKRIPSI = "@dokumenKerjasama/UPDATE_DESKRIPSI";
export const UPDATE_PIC_UMN = "@dokumenKerjasama/UPDATE_PIC_UMN";
export const UPDATE_TANGGAL_MULAI = "@dokumenKerjasama/UPDATE_TANGGAL_MULAI";
export const UPDATE_TANGGAL_SELESAI = "@dokumenKerjasama/UPDATE_TANGGAL_SELESAI";
export const UPDATE_STATUS = "@dokumenKerjasama/UPDATE_STATUS";
export const UPDATE_FILE = "@dokumenKerjasama/UPDATE_FILE";
export const DELETE_FILE = "@dokumenKerjasama/DELETE_FILE";

export const UPDATE_ANGGOTA = "@dokumenKerjasama/UPDATE_ANGGOTA";
export const UPDATE_PELAKSANA = "@dokumenKerjasama/UPDATE_PELAKSANA";
export const UPDATE_PARTNER = "@dokumenKerjasama/UPDATE_PARTNER";
export const UPDATE_BENTUK_KERJASAMA = "@dokumenKerjasama/UPDATE_BENTUK_KERJASAMA";

export const GET_DOKUMEN_KERJASAMA_REQUEST = "@dokumenKerjasama/GET_DOKUMEN_KERJASAMA_REQUEST";
export const GET_DOKUMEN_KERJASAMA_SUCCESS = "@dokumenKerjasama/GET_DOKUMEN_KERJASAMA_SUCCESS";
export const GET_DOKUMEN_KERJASAMA_FAILURE = "@dokumenKerjasama/GET_DOKUMEN_KERJASAMA_FAILURE";

export const GET_DETAIL_DOKUMEN_KERJASAMA_REQUEST = "@dokumenKerjasama/GET_DETAIL_DOKUMEN_KERJASAMA_REQUEST";
export const GET_DETAIL_DOKUMEN_KERJASAMA_SUCCESS = "@dokumenKerjasama/GET_DETAIL_DOKUMEN_KERJASAMA_SUCCESS";
export const GET_DETAIL_DOKUMEN_KERJASAMA_FAILURE = "@dokumenKerjasama/GET_DETAIL_DOKUMEN_KERJASAMA_FAILURE";

export const UPDATE_DOKUMEN_KERJASAMA_REQUEST = "@dokumenKerjasama/UPDATE_DOKUMEN_KERJASAMA_REQUEST";
export const UPDATE_DOKUMEN_KERJASAMA_SUCCESS = "@dokumenKerjasama/UPDATE_DOKUMEN_KERJASAMA_SUCCESS";
export const UPDATE_DOKUMEN_KERJASAMA_FAILURE = "@dokumenKerjasama/UPDATE_DOKUMEN_KERJASAMA_FAILURE";

export const CREATE_DOKUMEN_KERJASAMA_REQUEST = "@dokumenKerjasama/CREATE_DOKUMEN_KERJASAMA_REQUEST";
export const CREATE_DOKUMEN_KERJASAMA_SUCCESS = "@dokumenKerjasama/CREATE_DOKUMEN_KERJASAMA_SUCCESS";
export const CREATE_DOKUMEN_KERJASAMA_FAILURE = "@dokumenKerjasama/CREATE_DOKUMEN_KERJASAMA_FAILURE";